import api from "../api/axios";

export const customerService = {
  create: (data) => api.post("/customer/create", data),
  list: () => api.get("/customer/list"),
  getNextNumber: () => api.get("/customer/get-next-number"),
  update: (data) => api.post("/customer/update", data),
  delete: (id) => api.post("/customer/delete", { id }),
  getById: (id) => api.get(`/customer/get-customer/${id}`),
  getCustomerDetail: (customerId) => api.get(`/customer/${customerId}/detail`),
  getPaymentDetail: (transactionId) => api.get(`/customer/get-payment-detail/${transactionId}`),
  getAllCollections: () => api.get("/customer/all-collections"),
  receivePayment: (data) => api.post("/customer/receive-payment", data),
  adjustBalance: (data) => api.post("/customer/adjust-balance", data),
  applyDiscount: (data) => api.post("/customer/apply-discount", data),
  updatePayment: (data) => api.post("/customer/update-payment", data),
  deletePayment: (transactionId) => api.post("/customer/delete-payment", { transactionId }),

  createReturn: (data) => api.post("/return/create", data),
  createSaleReturn: (data) => api.post("/return/create-sale-return", data),
  listReturns: () => api.get("/return/list"),
  importExcel: (formData) => api.post("/customer/import-excel", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  }),
  downloadSample: () => api.get("/customer/download-sample", { responseType: "blob" })
};